import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  DatePicker,
  Divider,
  Image,
  Input,
  Menu,
  Modal,
  Row,
  Select,
  message,
  Tooltip,
  Alert,
} from "antd";
import AuthService from "../auth/AuthService";
import config, { tms_uploads_cdn } from "../config";
import { vehicleServiceTasks } from "../common/constants";
import dayjs from "dayjs";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Button as UploadButton, IconButton } from "@mui/material";
import { CloseOutlined } from "@ant-design/icons";
import qs from "query-string";
import { hideLoading, showLoading, useLoadingDispatch } from "../../context/loadingContext";
import moment from "moment";
import DeleteIcon from "@mui/icons-material/Delete";


const Auth = new AuthService();

const ResolveContactModal = ({ isModalOpen, setIsModalOpen, selectedRecord, setSelectedRecord, getData }) => {
  const { Option } = Select;
  const { TextArea } = Input;
  var layoutDispatch = useLoadingDispatch();

  const currentDate = new Date();
  const [dueDate, setDueDate] = useState(null);
  const [dueDateNext, setDueDateNext] = useState(null);
  const [completionDate, setCompletionDate] = useState(currentDate);

  const [files, setFiles] = useState([]);
  const [currentItemFiles, setCurrentItemFiles] = useState([]);
  const [deletedFiles, setDeletedFiles] = React.useState([]);
  const [notes, setNotes] = React.useState("");


  useEffect(()=>{
    if(selectedRecord) {
      setDueDate(selectedRecord?.due_date ? new Date(selectedRecord?.due_date) : null)
      setCurrentItemFiles(selectedRecord?.files ? JSON.parse(selectedRecord?.files) : [])
      setNotes(selectedRecord?.notes || '')

    }
  },[selectedRecord])

  useEffect(() => {
    if (completionDate) {
        const nextDueDate = dayjs(completionDate).add(6 || 0, 'month');
        setDueDateNext(nextDueDate.toDate());
    }
  }, [completionDate]);


  const handleCancel = () => {
    setIsModalOpen(false);
    resetState();
  };

  const handleOk = async () => {
    const isEmptyOrUndefined = (value) => value === '' || value === null || value === undefined;
    if(isEmptyOrUndefined(completionDate)) {
    message.error('Please enter completion date')
    return;
    }
    showLoading(layoutDispatch);
    const dataToSend = {
      driver_id : selectedRecord?.driver_id,
      id: selectedRecord?.id, 
      files: currentItemFiles,
      notes: notes,
      next_due_date: dueDateNext ? moment(dueDateNext).format('YYYY-MM-DD') : null,
      completion_date: completionDate ? moment(completionDate).format('YYYY-MM-DD') : null
    }
    try {
      const res = await Auth.fetch("/driver/resolve-driver-contact", {
        method: "POST",
        body: JSON.stringify(dataToSend),
      })
      if(res?.ack) {    
        const uploadPromises = []
        if (files.length > 0) {
          files.forEach((f) => {
            uploadPromises.push(
              getUploadUrl(f, selectedRecord?.id)
                .then(uploadUrl => uploadFileToS3(uploadUrl, f.file, f.file.type))
                .catch(error => console.error("Error uploading file:", error))
            );
          });
        }
        await Promise.all(uploadPromises);    
        message.success(res?.message)
        setIsModalOpen(false);
        // window.location.reload()
        getData()
        resetState()
      } else {
        message.error(res?.message)
      }

    } catch (err) {
      console.log(err);
    } 
    finally {
      // setIsModalOpen(false);
    hideLoading(layoutDispatch);
    }
  };


  const resetState = () => {
    // setDueDate(null)
    setDueDateNext(null)
    setCompletionDate(new Date())
    setNotes('');
    setFiles([]);
    setCurrentItemFiles([]);
    setDeletedFiles([]);
    setSelectedRecord('')
  };

  useEffect(() => {
    message.config({
      top: window.innerHeight - 100, 
      duration: 3, 
    });
  }, [])

  const handleSubmitImage = (e) => {
    e.preventDefault();
    let acceptedFiles = e.target.files;

    for (let file of acceptedFiles) {
      const randomString = Math.random().toString(36).substring(2, 10);
      const newFileName = `${file.name.split(".")[0]}-${randomString}.${
        file.name.split(".")[1]
      }`;
      setFiles((prevFiles) => [
        ...prevFiles,
        {
          name: newFileName,
          display_name: newFileName,
          file: file,
          ContentType: file.type,
        },
      ]);
      setCurrentItemFiles((prevFiles) => [...prevFiles, newFileName]);
    }
  };

  const handleDeleteFile = (fileName) => {
    const updatedFiles = files?.filter((file) => file.name !== fileName);
    setFiles(updatedFiles);
    setCurrentItemFiles(currentItemFiles?.filter((item) => item !== fileName));
  };

  const handleDeleteCurrentFile = (itemToDelete) => {
    setCurrentItemFiles(
      currentItemFiles.filter((item) => item !== itemToDelete)
    );
    if (!deletedFiles.includes(itemToDelete)) {
      setDeletedFiles((prevDeletedFiles) => [
        ...prevDeletedFiles,
        itemToDelete,
      ]);
    }
  };

  const getUploadUrl = async (file, recordID) => {
    const params = {
      bucket: config.tms_uploads_bucket,
      ContentType: file.file.type,
      Key: config.env + "/driver_contacts/" + recordID + "/" + file.name,
    };
    const response = await fetch(
      `${config.domain}/generate-put-url?${qs.stringify(params)}`,
      {
        headers: {
          "Content-Type": params.ContentType,
        },
      }
    );
    return response.json();
  };

  const uploadFileToS3 = async (uploadUrl, file, contentType) => {
    const response = await fetch(uploadUrl.putURL, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": contentType,
      },
    });
    if (response.status !== 200) {
      throw new Error("File upload failed.");
    }
  };

  const disabledDate = (current) => {
    return current && current < dayjs().startOf('day');
  };

  return (
    <>
      <Modal
        width={800}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        title={"Resolve Driver Contact"}
        footer={[
          <>
            <Button onClick={handleCancel}>{"Cancel"}</Button>
            <Button type="primary" onClick={handleOk}>
              {"Resolve"}
            </Button>
          </>,
        ]}
      >
        <>
          <Divider />
          <Row style={{marginTop: '5px'}} gutter={[16, 16]}>
            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <span>
             Completion Date<span style={{ color: "red", fontSize: "15px" }}>*</span>:
            </span>
            <DatePicker
              format={"YYYY-MM-DD"}
              value={completionDate ? dayjs(completionDate) : null}
              onChange={(_, dateStr) => {
                setCompletionDate(dateStr);
              }}
              style={{
                width: "100%",
              }}
              placeholder="Select date"
              // disabledDate={disabledDate}
            />
            </Col>
          </Row>
          <Row style={{marginTop: '5px'}} gutter={[16, 16]}>
          <Col xs={24} sm={12} md={12} lg={12} xl={12}>
            <span>
              Notes:
            </span>
                <TextArea value={notes} onChange={(e)=> setNotes(e.target.value)} autoSize={{ minRows: 3, maxRows: 6 }} />
            </Col>
          </Row>
          <Divider />
          <>
          <div>
        <UploadButton
          component="label"
          variant="contained"
          sx={{ marginTop: "10px" }}
          startIcon={<CloudUploadIcon />}
        >
          Add files
          <input
            type="file"
            hidden
            multiple
            capture
            // accept="image/*, video/*"
            // onChange={(e) => {
            //   handleSubmitImage(e);
            // }}
            onChange={(e) => {
                          const myfiles = e.target.files;
                          if (myfiles.length > 10) {
                            message.error("A maximum of 10 images can be uploaded at a time.");
                            e.target.value = "";
                          } else {
                            handleSubmitImage(e);
                          }
                        }}
          />
        </UploadButton>
      </div>
      {currentItemFiles?.length > 0 && <h4>Old Files:</h4>}
      <ul>
                  {currentItemFiles?.length > 0 &&
                    currentItemFiles
                      .filter(
                        (item) =>
                          !files.some((file) => file.name === item)
                      )
                      .map((item) => {
                        const lastHyphenIndex = item.lastIndexOf("-");
                        const dotBeforeExtensionIndex = item.lastIndexOf(".");
                        const newFileName =
                          item.slice(0, lastHyphenIndex) +
                          item.slice(dotBeforeExtensionIndex);
                        return (
                          <li>
                                <IconButton
                                  aria-label="delete"
                                  color="primary"
                                  onClick={() => handleDeleteCurrentFile(item)}
                                >
                                  <DeleteIcon />
                                </IconButton>

                            <a
                              href={`${config.tms_uploads_cdn}/${config.env}/driver_contacts/${selectedRecord?.id}/${item}`}
                              target="_blank"
                            >
                              {newFileName}
                            </a>
                          </li>
                        );
                      })}
                </ul>
      {/* <Image.PreviewGroup>
        {currentItemFiles?.length > 0 &&
          currentItemFiles
            .filter((item) => !files.some((file) => file.name === item))
            .map((item) => {
              const imageUrl = `${config.tms_uploads_cdn}/${config.env}/driver_contacts/${selectedRecord?.id}/${item}`;
              return (
                <div
                  style={{
                    position: "relative",
                    marginRight: "10px",
                    display: "inline-block",
                  }}
                >
                  <Image
                    width={200}
                    height={150}
                    style={{ padding: "5px", border: "1px solid lightgrey" }}
                    src={imageUrl}
                  />
                  <Tooltip title="Delete">
                    <CloseOutlined
                      style={{
                        fontSize: "30px",
                        position: "absolute",
                        right: 5,
                        top: 5,
                        color: "#c12828",
                      }}
                      onClick={() => handleDeleteCurrentFile(item)}
                    />
                  </Tooltip>
                  
                </div>
              );
            })}
      </Image.PreviewGroup> */}
        <Divider />
      {files?.length > 0 && <h4>New Files:</h4>}
      <ul>
                  {files.length > 0 &&
                    files.map((files) => {
                      return (
                        <li>
                          {" "}
                          <IconButton
                            aria-label="delete"
                            color="primary"
                            onClick={() => handleDeleteFile(files.name)}
                          >
                            <DeleteIcon />
                          </IconButton>
                          {files.name}
                        </li>
                      );
                    })}
                </ul>
      {/* <Image.PreviewGroup>
        {files?.length > 0 &&
          files.map((files) => {
            return (
              <div
                style={{
                  position: "relative",
                  marginRight: "10px",
                  display: "inline-block",
                }}
              >
                <Image
                  width={200}
                  height={150}
                  style={{ padding: "5px", border: "1px solid lightgrey" }}
                  src={URL.createObjectURL(files.file)}
                />
                <Tooltip title="Delete">
                  <CloseOutlined
                    style={{
                      fontSize: "30px",
                      position: "absolute",
                      right: 5,
                      top: 5,
                      color: "#c12828",
                    }}
                    onClick={() => handleDeleteFile(files.name)}
                  />
                </Tooltip>
              </div>
            );
          })}
      </Image.PreviewGroup> */}
            
          </>

          <>
        <Alert 
        message={`Next Due Date: ${moment(dueDateNext).format('YYYY-MM-DD')} , Occurs every six months`}
        // description={
        // <>
        // <span>{`Next Due Date: ${moment(dueDateNext).format('YYYY-MM-DD')}  `}</span><br/>
        // <span>{`every six months  `}</span>
        // </>
        // } 
        type="info" 
        showIcon />
        </>
        </>
      </Modal>
    </>
  );
};

export default ResolveContactModal;
